import React, { Component } from "react";
import { Container, Grid } from "@material-ui/core";
import EContentDescription from "./EContentDescription";
import "../section-sidebar.css";


const list = [
  {
    title: "Class Notes",
    link: "/e-content/class_note",
  },
  {
    title: "Class Videos",
    link: "/e-content/class_videos",
  },
  {
    title: "Assignments",
    link: "/e-content/class_assignments",
  },
  {
    title: "Classnote Requisitions",
    link: "/e-content/class_note_requisition",
  },
  
];

class EContent extends Component {
  state = {
    link: "",
    query: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  getLastLink = (link) => {
    let ll = link.split('/');
    if(ll.length > 0){
      return ll[ll.length - 1]
    }else{
      return '';
    }
  }

  render() {
    const query = this.state.query.trim().toLowerCase();
    const filtered = query
      ? list.filter((el) => el.title.toLowerCase().includes(query))
      : list;

    return (
      <div className="snav-wrap">
        <Container style={{ minHeight: "500px" }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <nav className="snav-side">
                <div className="snav-side-head">E-Contents</div>
                <div className="snav-search">
                  <div className="snav-search-field">
                    <span className="fa fa-search" aria-hidden="true" />
                    <input
                      type="text"
                      className="snav-search-input"
                      placeholder="Search..."
                      value={this.state.query}
                      onChange={(e) =>
                        this.setState({ query: e.target.value })
                      }
                    />
                  </div>
                </div>
                <ul className="snav-side-list">
                  {filtered.length === 0 ? (
                    <li className="snav-side-empty">No matching items</li>
                  ) : (
                    filtered.map((el, index) => (
                      <li
                        key={index}
                        className={`snav-side-item${
                          el.link === `/e-content/${this.state.link}`
                            ? " active"
                            : ""
                        }`}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <span className="snav-dot" />
                        {el.title}
                      </li>
                    ))
                  )}
                </ul>
              </nav>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9}>
              <div style={{ padding: 10 }}>
                <EContentDescription type={this.state.link} />
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default EContent;
